import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import '../../assets/css/style.css';

import { Formik, Form, Field, ErrorMessage } from 'formik';
import { Redirect, Link } from 'react-router-dom';

// import RegistryMap from '../shared/RegistryMap.jsx';

import * as api from '../../api/api';

class CheckpointInfoPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      checkpointData: {
        // latitude: 57.15,
        // longitude: 65.53
      },
      returnUrl: new URLSearchParams(this.props.location.search).get(
        'return_url',
      ),
      needRedirect: false,
    };

    this.props.updateLoader({
      loaded: false,
      message: '',
    });
  }

  componentDidMount() {
    if (!api.isUserAdmin()) {
      this.setState({
        returnUrl: '/users/permission-denied',
        needRedirect: true,
      });

      return;
    }

    if (this.props.match.params.id != 0) {
      api
        .makeRequest(api.getCheckpointDetails(this.props.match.params.id))
        .then(
          (response) => {
            this.setState({
              checkpointData: response.data.data,
            });

            this.props.updateLoader({
              loaded: true,
            });
          },
          (error) => {
            this.setState({
              checkpointData: null,
            });

            this.props.updateLoader({
              loaded: true,
              message: 'Ошибка при получении информации о остановке: ' + error,
            });
          },
        );
    } else {
      this.setState({
        checkpointData: {
          id: 0,
          name: '',
          description: '',
          externalSystemI: 0,
          latitude: 0,
          longitude: 0,
          busTimeStart: '',
          busTimeStart: '',
        },
      });

      this.props.updateLoader({
        loaded: true,
      });
    }
  }

  save(checkpointData) {
    this.props.updateLoader({
      loaded: false,
    });

    const dataToSave = Object.assign({}, checkpointData);
    delete dataToSave.id;

    api
      .makeRequest(api.saveCheckpoint(this.state.checkpointData.id, dataToSave))
      .then(
        (response) => {
          this.props.updateLoader({
            loaded: true,
          });

          this.setState({
            needRedirect: true,
          });
        },
        (error) => {
          this.props.updateLoader({
            loaded: true,
            message: 'Ошибка при сохранении: ' + error,
          });
        },
      );
  }

  handleMapClick(coords) {
    // this.setState({
    //     checkpointData: {
    //         latitude: coords[0],
    //         longitude: coords[1]
    //     }
    // });
    // console.log(coords);
  }

  render() {
    if (this.state.needRedirect) {
      return <Redirect to={this.state.returnUrl} />;
    }

    return (
      <div>
        <h4 className="mb-4">
          {this.props.match.params.id == 0
            ? 'Создание нового остановочного пункта'
            : 'Редактирование остановочного пункта'}
        </h4>

        {/* <div className="row">
                    <div className="col-md-7"> */}
        <Formik
          initialValues={this.state.checkpointData}
          //TODO: поправить
          enableReinitialize={true}
          //
          validate={(values) => {
            let errors = {};

            if (!values.name) {
              errors.name = 'Пожалуйста, заполните это поле';
            }

            if (!values.description) {
              errors.description = 'Пожалуйста, заполните это поле';
            }

            if (!values.latitude) {
              errors.latitude = 'Пожалуйста, заполните это поле';
            }

            if (!values.longitude) {
              errors.longitude = 'Пожалуйста, заполните это поле';
            }

            if (!values.busTimeStart) {
              errors.busTimeStart = 'Пожалуйста, заполните это поле';
            }

            if (!values.busTimeEnd) {
              errors.busTimeEnd = 'Пожалуйста, заполните это поле';
            }

            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            this.save(values);
          }}
        >
          {({ isSubmitting }) => (
            <Form className="">
              <div className="form-group">
                <label>Название</label>
                <Field className="form-control" type="text" name="name" />
                <ErrorMessage
                  className="form-error-message"
                  name="name"
                  component="div"
                />
              </div>
              <div className="form-group">
                <label>Описание</label>
                <Field
                  className="form-control"
                  type="text"
                  name="description"
                />
                <ErrorMessage
                  className="form-error-message"
                  name="description"
                  component="div"
                />
              </div>
              <div className="form-group">
                <label>АСД ID</label>
                <Field className="form-control" type="text" name="asdId" />
                <ErrorMessage
                  className="form-error-message"
                  name="asdId"
                  component="div"
                />
              </div>
              <div className="form-group">
                <label>Широта</label>
                <Field className="form-control" type="text" name="latitude" />
                <ErrorMessage
                  className="form-error-message"
                  name="latitude"
                  component="div"
                />
              </div>
              <div className="form-group">
                <label>Долгота</label>
                <Field className="form-control" type="text" name="longitude" />
                <ErrorMessage
                  className="form-error-message"
                  name="longitude"
                  component="div"
                />
              </div>
              <div className="form-group">
                <label>Начало следования ТС</label>
                <Field
                  className="form-control"
                  type="time"
                  name="busTimeStart"
                />
                <ErrorMessage
                  className="form-error-message"
                  name="busTimeStart"
                  component="div"
                />
              </div>
              <div className="form-group">
                <label>Окончание следования ТС</label>
                <Field className="form-control" type="time" name="busTimeEnd" />
                <ErrorMessage
                  className="form-error-message"
                  name="busTimeEnd"
                  component="div"
                />
              </div>

              <button
                className="btn btn-primary-custom"
                type="submit"
                disabled={false}
              >
                Сохранить
              </button>
              <button
                className="btn btn-secondary ml-2 btn-with-link"
                type="button"
              >
                <Link to={this.state.returnUrl}>Назад</Link>
              </button>
            </Form>
          )}
        </Formik>
        {/* </div> */}
        {/* <div className="col-md-5">
                        <RegistryMap
                            mapSettings={{ center: [57.15, 65.53], zoom: 9 }}
                            mapMarkers={[
                                {
                                    title: this.state.checkpointData.name,
                                    coordinates: [this.state.checkpointData.latitude, this.state.checkpointData.longitude]
                                }
                            ]}
                            onClick = {this.handleMapClick}
                        />
                    </div> */}
        {/* </div> */}
      </div>
    );
  }
}

export default CheckpointInfoPage;
